<template>
    <div class="bg-white">
        <CContainer>
            <div class="settings-container">
                <!-- Back Button -->
                <CRow class="header-row mb-3 position-relative">
                    <!-- Back Button on the Left -->
                    <CCol class="col-auto">
                        <CButton class="back-button" @click="$router.go(-1)">
                            ←
                        </CButton>
    
                    </CCol>
    
                    <!-- Centered Title -->
                    <CCol class="d-flex justify-content-center position-absolute start-50 translate-middle-x">
                        <h3 class="section-title m-0">Setting</h3>
                    </CCol>
                </CRow>
    
                <!-- Profile Section -->
                <div class="profile-card mt-3">
                    <br /> <br />
                    <div class="profile-info">
                        <img :src="user.filePath" alt="Profile" class="profile-image" />
                        <div class="profile-details">
                            <h4 class="profile-name font-color-171717">{{ user.name }}</h4>
                            <p class="profile-email">{{ user.email }}</p>
                        </div>
                        <CButton color="light" class="edit-profile border-half" @click="GoEdit()">Edit profile</CButton>
                    </div>
                </div>
    
                <!-- Main Settings -->
                <h3 class="section-title">Main Settings</h3>
                <div class="settings-card">
                    <div>
                        <SettingItem image="img/new/icondashboard.png" label="Dashboard" v-if="user.userType === 'company'" @click="GoToDashboard" />
                        <SettingItem image="img/new/crown.png" label="Rewards" />
                        <SettingItem image="img/new/password.png" label="Password" @click="GoToForgot" />
                        <SettingItem image="img/new/noti-setting.png" label="Notification Preferences" @click="GoToNotification" />
                        <SettingItem image="img/new/appear.png" label="Appearance" />
                        <SettingItem image="img/new/language.png" label="Language" />
                        <SettingItem image="img/new/crown.png" label="Manage Subscriptions" />
                        <SettingItem image="img/new/crown.png" label="Payment" />
                    </div>
                </div>
    
                <!-- Support & Feedback -->
                <h3 class="section-title">Support & Feedback</h3>
                <div class="settings-card">
                    <div>
                       
                        <SettingItem image="img/new/help.png" label="Help Center"  @click="GoToHelp"/>
                        <SettingItem image="img/new/help.png" label="Help Documentation"  @click="GoToHelpDoc"/>
                        <SettingItem image="img/new/call2.png" label="Contact Support"  @click="GoToContact"/>
                        <SettingItem image="img/new/call2.png" label="Terms & Conditions" @click="GoToLegal"/>
                    </div>
                </div>
    
                <!-- Log Out Button -->
                <CButton class="logout-button" color="danger" variant="outline" block v-on:click="SignOut()">
                    Log Out
                </CButton>
    
                <br /><br />     <br /><br />
            </div>
        </CContainer>
        <Footerlayout></Footerlayout>
    </div>
</template>
  
<script>
import Mainlayout from "../containers/AllHeader.vue";
import SettingItem from "@/components/SettingItem.vue"; // A reusable setting item component
import crownImage from '@/assets/img/new/crown.png'; // Import the image
import Footerlayout from "../containers/TheBottomCustom.vue";
export default {
    components: {
        SettingItem,
        Mainlayout,
        Footerlayout
    },
    data() {
        return {
            crownImage, // Assign imported image to data
            user: {}
        };

    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                this.GetInfoUser();
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            GoToLogin
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoEdit() {
            this.$router.push("ProfileUser");
        },
        GoToForgot() {
            this.$router.push("ForgotPassword");
        },
        GoToNotification() {
            this.$router.push("NotificationSetting");
        },
        GoToHelp()
        {
          this.$router.push("HelpCenter");

        },
        GoToLegal()
        {
          this.$router.push("Legal");

        },
        GoToHelpDoc()
        {
            window.open("https://www.surpriz.ing/customer/support.pdf");

        },
        GoToContact()
        {
          this.$router.push("ContactUs");

        },
        SignOut: function () {
        return this.$API
            .get(this.$SignOut, {
            withCredentials: true,
            })
            .then((response) => {
            if (response.status == 200) {
                this.$router.push("/Login");
            }
            });
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        GoToDashboard()
        {
            this.$router.push("Dashboard");
        }
    }
};
</script>
  
<style scoped>
.header {
    display: flex;
    align-items: center;
    position: relative;
}

.settings-container {
    text-align: center;
    padding: 20px;
}

.back-button {
    position: absolute;
    left: 10px;
    top: 10px;
}

.title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 20px;
}

.profile-card {
    border-radius: 16px;
    margin-bottom: 20px;
}

.profile-info {
    display: flex;
    align-items: center;
    padding: 16px;
    border-radius: 24px;
    background: var(--Colors-Background-tertiary-bg-color, #F3F4F6);
}

.profile-image {
    width: 50px;
    height: 50px;
    border-radius: 50%;
}

.profile-details {
    flex: 1;
    text-align: left;
    margin-left: 10px;
}

.profile-name {
    font-size: 14px;
    font-weight: 500;
}

.profile-email {
    font-size: 12px;
    color: #9DA4AE;
    font-weight: 400;
}

.edit-profile {
    font-size: 12px;
    font-weight: 500;
    padding: 5px 10px;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
    text-align: left;
}

.settings-card {
    border-radius: 16px;
    background: #F3F4F6;
    padding: 10px;
}

.logout-button {
    margin-top: 20px;
    font-size: 16px;
    border-radius: 30px;
    height: 50px;
}

.page-title {
    text-align: center;
    flex: 1;
    font-size: 20px;
    font-weight: bold;
}
</style>